var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShiftyPmLogoLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 160",
    width: 480,
    height: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "spokes",
    stroke: "#F0997B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 80,
    x2: 80,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 80,
    x2: 131,
    y2: 51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 80,
    x2: 129,
    y2: 111
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 80,
    x2: 80,
    y2: 136
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 80,
    x2: 29,
    y2: 111
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 80,
    x2: 29,
    y2: 51
  })), /*#__PURE__*/React.createElement("g", {
    id: "node-top"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 18,
    r: 13,
    fill: "#FAECE7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 18,
    r: 7,
    fill: "#D85A30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "node-top-right"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 48,
    r: 10,
    fill: "#FAECE7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 48,
    r: 5.5,
    fill: "#D85A30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "node-bot-right"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 133,
    cy: 114,
    r: 8,
    fill: "#FAECE7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133,
    cy: 114,
    r: 4,
    fill: "#D85A30",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "node-bottom"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 142,
    r: 13,
    fill: "#FAECE7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 142,
    r: 7,
    fill: "#D85A30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "node-bot-left"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 114,
    r: 10,
    fill: "#FAECE7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 114,
    r: 5.5,
    fill: "#D85A30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "node-top-left"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 48,
    r: 8,
    fill: "#FAECE7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 48,
    r: 4,
    fill: "#D85A30",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "hub"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 16,
    fill: "#D85A30"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 7,
    fill: "#FFFFFF"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "wordmark",
    fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif"
  }, /*#__PURE__*/React.createElement("text", {
    x: 176,
    y: 96,
    fontSize: 64,
    fontWeight: 500,
    letterSpacing: -1.5
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#D85A30"
  }, "Shifty"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#2C2C2A"
  }, "PM")), /*#__PURE__*/React.createElement("text", {
    x: 177,
    y: 122,
    fontSize: 13,
    fontWeight: 400,
    letterSpacing: 4,
    fill: "#B4B2A9"
  }, "AI PROJECT MANAGEMENT"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiftyPmLogoLight);
export default __webpack_public_path__ + "static/media/ShiftyPM_Logo_Light.b0b12e24f68bcd75cbb23bce7278d4bd.svg";
export { ForwardRef as ReactComponent };